import { onMounted, ref, watch, WatchSource } from 'vue';

// Liefert erst nach dem ersten Frame `true`, damit Balken von 0 auf ihren Wert wachsen.
// Bei Änderung der Quelle (z. B. Saisonwechsel) startet die Animation erneut.
export function useGrow(source?: WatchSource) {
  const grown = ref(false);

  const replay = () => {
    grown.value = false;
    requestAnimationFrame(() => requestAnimationFrame(() => {
      grown.value = true;
    }));
  };

  onMounted(replay);
  if (source) {
    watch(source, replay);
  }

  return grown;
}
